import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6326acb0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6326acb0&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=6326acb0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6326acb0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6326acb0')) {
      api.createRecord('6326acb0', component.options)
    } else {
      api.reload('6326acb0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6326acb0&scoped=true", function () {
      api.rerender('6326acb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/components/message/index.vue"
export default component.exports